module.exports = __webpack_public_path__ + "static/media/rec-star-signin-bg.1674346d.jpg";